import {IFlightPax} from '@/firebase/flight';
import {IFlightItem} from '@/types/flight';
import {createSlice} from '@reduxjs/toolkit';

export interface UserState {
  flightData: IFlightItem[];
  flightDataReady: boolean;
  flightDetail: IFlightItem | null;
  flightPax: IFlightPax[];
  flightOptionsIds: string[];
}

const initialState: UserState = {
  flightData: [],
  flightDataReady: false,
  flightDetail: null,
  flightPax: [],
  flightOptionsIds: []
};

const flightSlice = createSlice({
  name: 'flightSlice',
  initialState,
  reducers: {
    setFlightData: (state, action) => {
      state.flightData = action.payload;
      state.flightDataReady = true;
    },
    setFlightDetail: (state, action) => {
      state.flightDetail = action.payload;
    },
    setFlightPax: (state, action) => {
      state.flightPax = action.payload;
    },
    setFlightOptionsIds: (state, action) => {
      state.flightOptionsIds = action.payload;
    }
  }
});

export const {
  setFlightData,
  setFlightDetail,
  setFlightPax,
  setFlightOptionsIds
} = flightSlice.actions;
export default flightSlice.reducer;
